import { render, staticRenderFns } from "./ImportProject.vue?vue&type=template&id=08fa72b7"
import script from "./ImportProject.vue?vue&type=script&lang=js"
export * from "./ImportProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports